import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HvlNgSharedModule, PrimengSharedModule } from '@hvlng/framework-core/shared';
import { UiSharedModule } from 'ui-shared';
import { TranslateModule } from '@ngx-translate/core';
import { TitleDropdownComponent } from './component/title-dropdown.component';

@NgModule({
    declarations: [TitleDropdownComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PrimengSharedModule,
        HvlNgSharedModule,
        UiSharedModule,
        TranslateModule,
    ],
    exports: [TitleDropdownComponent],
})
export class TitleDropdownModule {}
